import { injectGlobal } from 'styled-components'

import { colors } from '../../constants/style'

injectGlobal`
  .react-calendar {
    border: 1px solid ${colors.red};
    color: ${colors.red};
    user-select: none;
    button[type=button] {
      outline: none;
      background-color: white;
      border: none;
      color: ${colors.red};
    }
  }
  .react-calendar__navigation {
    border-bottom: 1px solid ${colors.red};
    padding: 4px 0;
    .react-calendar__navigation__label {
      font-size: 1.8rem;
      pointer-events: none;
    }
  }
  .react-calendar__month-view {
    padding: 15px 10px 0;
  }
  .react-calendar__navigation__arrow {
    width: 40px;
    height: 40px;
    cursor: pointer;
    text-align: center;
    svg {
      height: 100%;

    }
  }
  .react-calendar__navigation__prev2-button {
    display: none;
  }
  .react-calendar__navigation__next2-button {
    display: none;
  }

  .react-calendar__month-view__weekdays {
    margin-bottom: 10px;
    text-align: center;
    font-weight: bold;
  }

  .react-calendar__month-view  {
    height: 400px;
  }

  button[type=button].react-calendar__tile {
    cursor: pointer;
    font-weight: bold;
    height: 36px;
    margin-bottom: 20px;
    position: relative;
    white-space: nowrap;

    &.react-calendar__tile--active:before {
      border-width: 3px!important;
    }

    &.customTile {
      position: relative;
      > time {
        position: relative;
      }

      &:before {
        position: absolute;
        content: '';
        width: 35px;
        height: 35px;
        border: 1px solid ${colors.red};
        border-radius: 50%;
        left: 50%
        top: 0;
        transform: translateX(-50%);
      }
      &.customTile--hasEvent {
        color: white;
      }
      &.customTile--hasEventRed:before{
        background-color: ${colors.red};
        border-width: 0px;
      }
      &.customTile--hasEventGray:before{
        background-color: ${colors.gray};
        border-width: 0px;
      }
      &.customTile--hasMultipleEvent:before{
        background: linear-gradient(to right, ${colors.red} 50%, ${colors.gray} 50%);
        border-width: 0px;
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Calendar/style.js